import { AppStatus, RequestState } from '@models/Common'
import { Action } from '@utils/reducers/Action'
import environment from 'config/environment'
import { logReducerAction } from '../dev/devSessionLog'

type VoidFunction = () => void
export type NavigationState = RequestState & {
  isPrevEnabled: boolean
  isNextEnabled: boolean
  isResetEnabled: boolean
  isShareEnabled: boolean
  prevHandler?: VoidFunction
  nextHandler?: VoidFunction
  resetHandler?: VoidFunction
  shareHandler?: VoidFunction
  disableShare?: VoidFunction
  enableShare?: VoidFunction
}

export const initialState: NavigationState = {
  status: AppStatus.IDLE,
  errorMessage: undefined,
  isPrevEnabled: false,
  isNextEnabled: false,
  isResetEnabled: false,
  isShareEnabled: false,
  prevHandler: undefined,
  nextHandler: undefined,
  resetHandler: undefined,
  shareHandler: undefined,
}
export enum NavigationActionType {
  EnablePrevNavigation = 'EnablePrevNavigation',
  EnableNextNavigation = 'EnableNextNavigation',
  EnableResetNavigation = 'EnableResetNavigation',
  EnableShareNavigation = 'EnableShareNavigation',
  DisablePrevNavigation = 'DisablePrevNavigation',
  DisableNextNavigation = 'DisableNextNavigation',
  DisableResetNavigation = 'DisableResetNavigation',
  DisableShareNavigation = 'DisableShareNavigation',
  SetPrevHandler = 'SetPrevHandler',
  SetNextHandler = 'SetNextHandler',
  SetResetHandler = 'SetResetHandler',
  SetShareHandler = 'SetShareHandler',
}

const NavigationReducer = (
  state: NavigationState,
  action: Action<NavigationActionType, VoidFunction | undefined>,
): NavigationState => {
  if (environment.isDev) {
    // used in dev so its ok
    // eslint-disable-next-line no-console
    console.log('Navigate', { reducer: 'navigation', state, action })
    logReducerAction('navigation', action)
  }

  switch (action.type) {
    case NavigationActionType.EnablePrevNavigation:
      return { ...state, isPrevEnabled: true }
    case NavigationActionType.EnableNextNavigation:
      return { ...state, isNextEnabled: true }
    case NavigationActionType.EnableResetNavigation:
      return { ...state, isResetEnabled: true }
    case NavigationActionType.EnableShareNavigation:
      return { ...state, isShareEnabled: true }
    case NavigationActionType.DisablePrevNavigation:
      return { ...state, isPrevEnabled: false }
    case NavigationActionType.DisableNextNavigation:
      return { ...state, isNextEnabled: false }
    case NavigationActionType.DisableResetNavigation:
      return { ...state, isResetEnabled: false }
    case NavigationActionType.DisableShareNavigation:
      return { ...state, isShareEnabled: false }
    case NavigationActionType.SetPrevHandler: {
      const prevHandler = action.payload
      return { ...state, prevHandler, isPrevEnabled: !!prevHandler }
    }
    case NavigationActionType.SetNextHandler: {
      const nextHandler = action.payload
      return { ...state, nextHandler, isNextEnabled: !!nextHandler }
    }
    case NavigationActionType.SetResetHandler: {
      const resetHandler = action.payload
      return { ...state, resetHandler, isResetEnabled: !!resetHandler }
    }
    case NavigationActionType.SetShareHandler: {
      const shareHandler = action.payload
      return { ...state, shareHandler, isShareEnabled: !!shareHandler }
    }

    default:
      return state
  }
}
export default NavigationReducer
